/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PlayRouteImport } from './routes/play'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthVerifyEmailPendingRouteImport } from './routes/auth/verify-email-pending'
import { Route as AuthVerifyEmailRouteImport } from './routes/auth/verify-email'
import { Route as AuthSignUpRouteImport } from './routes/auth/sign-up'
import { Route as AuthSignInRouteImport } from './routes/auth/sign-in'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppQuizzesIndexRouteImport } from './routes/_app/quizzes/index'
import { Route as AppQuestionBankIndexRouteImport } from './routes/_app/question-bank/index'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppQuizzesNewRouteImport } from './routes/_app/quizzes/new'
import { Route as AppAdminUsersRouteImport } from './routes/_app/admin/users'
import { Route as AppAdminSessionsRouteImport } from './routes/_app/admin/sessions'
import { Route as AppAdminQuizzesRouteImport } from './routes/_app/admin/quizzes'
import { Route as AppAdminQuestionBankRouteImport } from './routes/_app/admin/question-bank'
import { Route as AppAdminOrganizationsRouteImport } from './routes/_app/admin/organizations'
import { Route as AppQuizzesQuizIdEditRouteImport } from './routes/_app/quizzes/$quizId/edit'
import { Route as AppGamesPlayGameIdRouteImport } from './routes/_app/games/play/$gameId'
import { Route as AppGamesHostGameIdRouteImport } from './routes/_app/games/host/$gameId'

const PlayRoute = PlayRouteImport.update({
  id: '/play',
  path: '/play',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyEmailPendingRoute = AuthVerifyEmailPendingRouteImport.update({
  id: '/auth/verify-email-pending',
  path: '/auth/verify-email-pending',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/auth/verify-email',
  path: '/auth/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/auth/sign-up',
  path: '/auth/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/auth/sign-in',
  path: '/auth/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppQuizzesIndexRoute = AppQuizzesIndexRouteImport.update({
  id: '/quizzes/',
  path: '/quizzes/',
  getParentRoute: () => AppRoute,
} as any)
const AppQuestionBankIndexRoute = AppQuestionBankIndexRouteImport.update({
  id: '/question-bank/',
  path: '/question-bank/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AppRoute,
} as any)
const AppQuizzesNewRoute = AppQuizzesNewRouteImport.update({
  id: '/quizzes/new',
  path: '/quizzes/new',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminSessionsRoute = AppAdminSessionsRouteImport.update({
  id: '/admin/sessions',
  path: '/admin/sessions',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminQuizzesRoute = AppAdminQuizzesRouteImport.update({
  id: '/admin/quizzes',
  path: '/admin/quizzes',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminQuestionBankRoute = AppAdminQuestionBankRouteImport.update({
  id: '/admin/question-bank',
  path: '/admin/question-bank',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminOrganizationsRoute = AppAdminOrganizationsRouteImport.update({
  id: '/admin/organizations',
  path: '/admin/organizations',
  getParentRoute: () => AppRoute,
} as any)
const AppQuizzesQuizIdEditRoute = AppQuizzesQuizIdEditRouteImport.update({
  id: '/quizzes/$quizId/edit',
  path: '/quizzes/$quizId/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppGamesPlayGameIdRoute = AppGamesPlayGameIdRouteImport.update({
  id: '/games/play/$gameId',
  path: '/games/play/$gameId',
  getParentRoute: () => AppRoute,
} as any)
const AppGamesHostGameIdRoute = AppGamesHostGameIdRouteImport.update({
  id: '/games/host/$gameId',
  path: '/games/host/$gameId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/play': typeof PlayRoute
  '/dashboard': typeof AppDashboardRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/auth/verify-email-pending': typeof AuthVerifyEmailPendingRoute
  '/admin/organizations': typeof AppAdminOrganizationsRoute
  '/admin/question-bank': typeof AppAdminQuestionBankRoute
  '/admin/quizzes': typeof AppAdminQuizzesRoute
  '/admin/sessions': typeof AppAdminSessionsRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/quizzes/new': typeof AppQuizzesNewRoute
  '/admin/': typeof AppAdminIndexRoute
  '/question-bank/': typeof AppQuestionBankIndexRoute
  '/quizzes/': typeof AppQuizzesIndexRoute
  '/games/host/$gameId': typeof AppGamesHostGameIdRoute
  '/games/play/$gameId': typeof AppGamesPlayGameIdRoute
  '/quizzes/$quizId/edit': typeof AppQuizzesQuizIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/play': typeof PlayRoute
  '/dashboard': typeof AppDashboardRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/auth/verify-email-pending': typeof AuthVerifyEmailPendingRoute
  '/admin/organizations': typeof AppAdminOrganizationsRoute
  '/admin/question-bank': typeof AppAdminQuestionBankRoute
  '/admin/quizzes': typeof AppAdminQuizzesRoute
  '/admin/sessions': typeof AppAdminSessionsRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/quizzes/new': typeof AppQuizzesNewRoute
  '/admin': typeof AppAdminIndexRoute
  '/question-bank': typeof AppQuestionBankIndexRoute
  '/quizzes': typeof AppQuizzesIndexRoute
  '/games/host/$gameId': typeof AppGamesHostGameIdRoute
  '/games/play/$gameId': typeof AppGamesPlayGameIdRoute
  '/quizzes/$quizId/edit': typeof AppQuizzesQuizIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/play': typeof PlayRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/auth/verify-email-pending': typeof AuthVerifyEmailPendingRoute
  '/_app/admin/organizations': typeof AppAdminOrganizationsRoute
  '/_app/admin/question-bank': typeof AppAdminQuestionBankRoute
  '/_app/admin/quizzes': typeof AppAdminQuizzesRoute
  '/_app/admin/sessions': typeof AppAdminSessionsRoute
  '/_app/admin/users': typeof AppAdminUsersRoute
  '/_app/quizzes/new': typeof AppQuizzesNewRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/question-bank/': typeof AppQuestionBankIndexRoute
  '/_app/quizzes/': typeof AppQuizzesIndexRoute
  '/_app/games/host/$gameId': typeof AppGamesHostGameIdRoute
  '/_app/games/play/$gameId': typeof AppGamesPlayGameIdRoute
  '/_app/quizzes/$quizId/edit': typeof AppQuizzesQuizIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/play'
    | '/dashboard'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/auth/verify-email'
    | '/auth/verify-email-pending'
    | '/admin/organizations'
    | '/admin/question-bank'
    | '/admin/quizzes'
    | '/admin/sessions'
    | '/admin/users'
    | '/quizzes/new'
    | '/admin/'
    | '/question-bank/'
    | '/quizzes/'
    | '/games/host/$gameId'
    | '/games/play/$gameId'
    | '/quizzes/$quizId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/play'
    | '/dashboard'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/auth/verify-email'
    | '/auth/verify-email-pending'
    | '/admin/organizations'
    | '/admin/question-bank'
    | '/admin/quizzes'
    | '/admin/sessions'
    | '/admin/users'
    | '/quizzes/new'
    | '/admin'
    | '/question-bank'
    | '/quizzes'
    | '/games/host/$gameId'
    | '/games/play/$gameId'
    | '/quizzes/$quizId/edit'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/play'
    | '/_app/dashboard'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/auth/verify-email'
    | '/auth/verify-email-pending'
    | '/_app/admin/organizations'
    | '/_app/admin/question-bank'
    | '/_app/admin/quizzes'
    | '/_app/admin/sessions'
    | '/_app/admin/users'
    | '/_app/quizzes/new'
    | '/_app/admin/'
    | '/_app/question-bank/'
    | '/_app/quizzes/'
    | '/_app/games/host/$gameId'
    | '/_app/games/play/$gameId'
    | '/_app/quizzes/$quizId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  PlayRoute: typeof PlayRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
  AuthVerifyEmailPendingRoute: typeof AuthVerifyEmailPendingRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/play': {
      id: '/play'
      path: '/play'
      fullPath: '/play'
      preLoaderRoute: typeof PlayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify-email-pending': {
      id: '/auth/verify-email-pending'
      path: '/auth/verify-email-pending'
      fullPath: '/auth/verify-email-pending'
      preLoaderRoute: typeof AuthVerifyEmailPendingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify-email': {
      id: '/auth/verify-email'
      path: '/auth/verify-email'
      fullPath: '/auth/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/auth/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quizzes/': {
      id: '/_app/quizzes/'
      path: '/quizzes'
      fullPath: '/quizzes/'
      preLoaderRoute: typeof AppQuizzesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/question-bank/': {
      id: '/_app/question-bank/'
      path: '/question-bank'
      fullPath: '/question-bank/'
      preLoaderRoute: typeof AppQuestionBankIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quizzes/new': {
      id: '/_app/quizzes/new'
      path: '/quizzes/new'
      fullPath: '/quizzes/new'
      preLoaderRoute: typeof AppQuizzesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/sessions': {
      id: '/_app/admin/sessions'
      path: '/admin/sessions'
      fullPath: '/admin/sessions'
      preLoaderRoute: typeof AppAdminSessionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/quizzes': {
      id: '/_app/admin/quizzes'
      path: '/admin/quizzes'
      fullPath: '/admin/quizzes'
      preLoaderRoute: typeof AppAdminQuizzesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/question-bank': {
      id: '/_app/admin/question-bank'
      path: '/admin/question-bank'
      fullPath: '/admin/question-bank'
      preLoaderRoute: typeof AppAdminQuestionBankRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/organizations': {
      id: '/_app/admin/organizations'
      path: '/admin/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AppAdminOrganizationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quizzes/$quizId/edit': {
      id: '/_app/quizzes/$quizId/edit'
      path: '/quizzes/$quizId/edit'
      fullPath: '/quizzes/$quizId/edit'
      preLoaderRoute: typeof AppQuizzesQuizIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/games/play/$gameId': {
      id: '/_app/games/play/$gameId'
      path: '/games/play/$gameId'
      fullPath: '/games/play/$gameId'
      preLoaderRoute: typeof AppGamesPlayGameIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/games/host/$gameId': {
      id: '/_app/games/host/$gameId'
      path: '/games/host/$gameId'
      fullPath: '/games/host/$gameId'
      preLoaderRoute: typeof AppGamesHostGameIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppDashboardRoute: typeof AppDashboardRoute
  AppAdminOrganizationsRoute: typeof AppAdminOrganizationsRoute
  AppAdminQuestionBankRoute: typeof AppAdminQuestionBankRoute
  AppAdminQuizzesRoute: typeof AppAdminQuizzesRoute
  AppAdminSessionsRoute: typeof AppAdminSessionsRoute
  AppAdminUsersRoute: typeof AppAdminUsersRoute
  AppQuizzesNewRoute: typeof AppQuizzesNewRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppQuestionBankIndexRoute: typeof AppQuestionBankIndexRoute
  AppQuizzesIndexRoute: typeof AppQuizzesIndexRoute
  AppGamesHostGameIdRoute: typeof AppGamesHostGameIdRoute
  AppGamesPlayGameIdRoute: typeof AppGamesPlayGameIdRoute
  AppQuizzesQuizIdEditRoute: typeof AppQuizzesQuizIdEditRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDashboardRoute: AppDashboardRoute,
  AppAdminOrganizationsRoute: AppAdminOrganizationsRoute,
  AppAdminQuestionBankRoute: AppAdminQuestionBankRoute,
  AppAdminQuizzesRoute: AppAdminQuizzesRoute,
  AppAdminSessionsRoute: AppAdminSessionsRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
  AppQuizzesNewRoute: AppQuizzesNewRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppQuestionBankIndexRoute: AppQuestionBankIndexRoute,
  AppQuizzesIndexRoute: AppQuizzesIndexRoute,
  AppGamesHostGameIdRoute: AppGamesHostGameIdRoute,
  AppGamesPlayGameIdRoute: AppGamesPlayGameIdRoute,
  AppQuizzesQuizIdEditRoute: AppQuizzesQuizIdEditRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  PlayRoute: PlayRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
  AuthVerifyEmailPendingRoute: AuthVerifyEmailPendingRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
